module.exports = __webpack_public_path__ + "ba653ea4b020bda3884b8489e9c1d1b1.jpg";